import { render, staticRenderFns } from "./MenuObserver.vue?vue&type=template&id=1ad8b2a6&"
import script from "./MenuObserver.vue?vue&type=script&lang=js&"
export * from "./MenuObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports